import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";
import "firebase/storage";
import config from "./config.js";

if (!firebase.apps.length) {
  firebase.initializeApp(config.services.firebase);
}

let cloneFunction = function(obj) {
  return JSON.parse(JSON.stringify(obj));
};
export const clone = cloneFunction;
export const GoogleProvider = new firebase.auth.GoogleAuthProvider();
export const auth = firebase.auth();
export const DB = firebase.firestore();
export const files = firebase.storage().ref();
export const generalRef = DB.collection("general");
export const usersRef = DB.collection("users");
export const goodCausesRef = DB.collection("goodCauses");
export const impactBusinessesRef = DB.collection("impactBusinesses");
export const featuredListingsRef = DB.collection("featuredListings");
export const businessesRef = DB.collection("businesses");
export const categoriesRef = DB.collection("categories");
export const sendSalesEnquiry = firebase
  .functions()
  .httpsCallable("sendSalesEnquiry");
export const sendGeneralEnquiry = firebase
  .functions()
  .httpsCallable("sendGeneralEnquiry");
export const sendSupplierJoinEnquiry = firebase
  .functions()
  .httpsCallable("sendSupplierJoinEnquiry");
export const sendGoodCauseJoinEnquiry = firebase
  .functions()
  .httpsCallable("sendGoodCauseJoinEnquiry");
export const sendImpactBusinessJoinEnquiry = firebase
  .functions()
  .httpsCallable("sendImpactBusinessJoinEnquiry");
export const setBusinessUser = firebase
  .functions()
  .httpsCallable("setBusinessUser");
export const sendAffiliateLinkNotice = firebase
  .functions()
  .httpsCallable("sendAffiliateLinkNotice");
export default firebase;
export const Timestamp = firebase.firestore.FieldValue.serverTimestamp();
export const sendContactFormData = firebase
  .functions()
  .httpsCallable("sendContactFormData");
export const affiliateLinkClicksRef = DB.collection("affiliateLinkClicks");
export const liveSync = DB.collection("liveSync");
